"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiffValues = void 0;
const lodash_1 = __importDefault(require("lodash"));
const isStringifiedJSON_1 = require("./isStringifiedJSON");
const getDiffValues = (attributes, oldObj, newObj, defaultValues = {}) => {
    return attributes.reduce((acc, attribute) => {
        const newValue = lodash_1.default.get(newObj, attribute);
        const oldValue = lodash_1.default.get(oldObj, attribute);
        if (!lodash_1.default.isEqual(oldValue, newValue)) {
            if (newValue === '') {
                if (!lodash_1.default.isEqual(oldValue, newValue)) {
                    lodash_1.default.set(acc, attribute, newValue);
                    return acc;
                }
            }
            if ((0, isStringifiedJSON_1.isStringifiedJSON)(newValue) &&
                (0, isStringifiedJSON_1.isStringifiedJSON)(oldValue)) {
                const parsedOldValue = JSON.parse(oldValue);
                const parsedNewValue = JSON.parse(newValue);
                if (lodash_1.default.isEqual(parsedOldValue, parsedNewValue)) {
                    return acc;
                }
            }
            if (typeof newValue === 'boolean') {
                lodash_1.default.set(acc, attribute, newValue);
                return acc;
            }
            if (newValue || lodash_1.default.has(defaultValues, attribute)) {
                lodash_1.default.set(acc, attribute, newValue || lodash_1.default.get(defaultValues, attribute));
                return acc;
            }
        }
        return acc;
    }, {});
};
exports.getDiffValues = getDiffValues;
//# sourceMappingURL=getDiffValues.js.map